export { default } from './carousel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-nuka-carousel/es/index.js
// module id = 307
// module chunks = 0